module.exports = __webpack_public_path__ + "static/media/partitionSubImg3.c8239937.png";